<style lang="scss">
.audit-header{
    position:fixed;
    height:45px;
    top:0;
    left:0;
    width:100%;
    padding:0 20px;
    background:#fff;
    z-index:100;
    border-bottom:1px solid #ccc;
}
  .audit-nav{
    height:100%;
    .nav-container{
      width:100%;
      height:100%;
      display:flex;
      align-items: center;
    }
    .logo{
      font-size:0;
      text-indent: -9999px;
      width:90px;
      height:28px;
      background:url('../img/header-logo.png') no-repeat center top;
      background-size: cover;
      a{
        display:block;
        height:100%;
      }
    }
    .hamburger-btn{
      width: 26px;
      height: 24px;
      position: relative;
      overflow:hidden;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: .5s ease-in-out;
      -moz-transition: .5s ease-in-out;
      -o-transition: .5s ease-in-out;
      transition: .5s ease-in-out;
      margin-left:auto;
      span{
        display: block;
        position: absolute;
        height: 3px;
        width: 100%;
        background: #000;
        opacity: 1;
        left: 0;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
        &:nth-child(1) {
          top: 0px;
        }
        &:nth-child(2) {
          top: 10px;
        }
        &:nth-child(3) {
          top: 20px;
        }
      }
      &.active{
        span{
          &:nth-child(1) {
            top: 10px;
            -webkit-transform: rotate(135deg);
            -moz-transform: rotate(135deg);
            -o-transform: rotate(135deg);
            transform: rotate(135deg);
          }
          &:nth-child(2) {
            opacity: 0;
            left: -60px;
          }
          &:nth-child(3) {
            top: 10px;
            -webkit-transform: rotate(-135deg);
            -moz-transform: rotate(-135deg);
            -o-transform: rotate(-135deg);
            transform: rotate(-135deg);
          }
        }
        &.open{
          position:absolute;
          top:11px;
          right:20px;
          z-index:100;
        }
      }
    }
  }
  .menu-area{
    display:none;
  }
  @media (min-width: 1200px) {
    .pc-container{
      width:1200px;
      margin:0 auto;
    }
    .hamburger-btn{
      display:none;
    }
    .audit-header{
      padding:0;
      height:100px;
       .audit-nav{
         .nav-container{
           width:1200px;
         }
         .logo{
           font-size: 0;
            text-indent: -9999px;
            width: 188px;
            height: 56px;
            background: url('../img/header-logo.png') no-repeat center top;
         }
      }
      .menu-area{
        display:block;
        margin-left:auto;
      }
      .menu-list{
        display:flex;
        justify-content: center;
        .list-item{
          a{
            font-size:23px;
            color:#000;
            font-weight: bold;
            margin-right:120px;
          }
          &:last-child{
            a{
              margin-right:0;
            }
          }
        }
      }
    }
  }
.menu-bg{
  background: #000;
  opacity: 0.7;
  position: fixed;
  top: 0;
  z-index: 90;
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  left: 0;
}
.mobile-menu{
  position:fixed;
  width:100%;
  height:100%;
  top:0;
  left:0;
  .menu-list{
    position:absolute;
    top:0;
    right:0;
    background:#fff;
    width:70%;
    height:100%;
    padding:65px 0 0 45px;
    z-index:100;
    .list-item{
      margin-bottom:45px;
      a{
        font-size:16px;
        font-weight: bold;
        color:#000;
      }
    }
  }
}
</style>
<template>
<header class="audit-header">
  <nav class="audit-nav">
      <div class="pc-container nav-container">
        <h1 class="logo">
          <!-- <a href="/">동아쏘시오 그룹 사이버감사실</a> -->
          <router-link to="/">동아쏘시오 그룹 사이버 감사실</router-link>
        </h1>
        <button type="button" class="hamburger-btn" :class="{ active: isActive , open: topMenuOpen}" @click="menuToggle()">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </button>
        <div class="menu-area">
          <ul class="menu-list">
            <li class="list-item">
              <!-- <router-link to="/#intro" class="menu-link">CLEAN :D 소개</router-link> -->
              <a href="/#intro-br" class="menu-link">CLEAN :D 소개</a>
            </li>
            <li class="list-item">
              <router-link to="/reportguide" class="menu-link">제보안내</router-link>
            </li>
            <li class="list-item">
              <router-link to="/reporting" class="menu-link">제보하기</router-link>
            </li>
            <li class="list-item">
              <router-link to="/reportinquiry" class="menu-link">제보확인</router-link>
            </li>
          </ul>
        </div>
        <div class="mobile-menu" v-if="topMenuOpen">
          <ul class="menu-list">
            <li class="list-item">
              <!-- <router-link to="/#mobileIntro" class="menu-link">CLEAN :D 소개</router-link> -->
              <a href="/#intro-br" class="menu-link">CLEAN :D 소개</a>
            </li>
            <li class="list-item">
              <router-link to="/reportguide" class="menu-link">제보안내</router-link>
            </li>
            <li class="list-item">
              <router-link to="/reporting" class="menu-link">제보하기</router-link>
            </li>
            <li class="list-item">
              <router-link to="/reportinquiry" class="menu-link">제보확인</router-link>
            </li>
          </ul>
          <div class="menu-bg">
          </div>
        </div>
      </div>
      <!-- <p :class="[`${windowWidth > 769 && windowWidth <= 1024 ? 'special__class':'normal__class'}`]">Resize me! Current width is: {{ windowWidth }}</p> -->
    </nav>
  </header>
</template>
<script>
const body = document.getElementsByTagName('body')[0]
export default {
  name: 'AuditHeader',
  data () {
    return {
      isActive: false,
      windowWidth: window.innerWidth,
      topMenuOpen: false
    }
  },
  methods: {
    menuToggle () {
      this.isActive = !this.isActive
      this.topMenuOpen = !this.topMenuOpen
      if (this.topMenuOpen === true) {
        body.classList.add('overflow')
      } else {
        body.classList.remove('overflow')
      }
    }
  },
  mounted () {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AuditHeader.vue